import React from 'react';

const DoubleArrowBack = ({width, height, color}) => {
    const getColor = (c) => {
        if (c === 'primary-500') return '#7F0689';
        if (c === 'secondary-500') return '#75D3A8';
        return c;
    };
    return (
        <svg width={width} height={height} viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="35" height="35" rx="17.5" transform="matrix(1 1.74846e-07 1.74846e-07 -1 0 35)"
                  fill={getColor(color) || '#7F0689'}/>
            <path d="M24.0625 23.125L18.4375 17.5L24.0625 11.875" stroke="white" strokeWidth="1.875"
                  strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16.5625 23.125L10.9375 17.5L16.5625 11.875" stroke="white" strokeWidth="1.875"
                  strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    );
};
export default DoubleArrowBack;
